// const BASE_API = "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod"

export const API_CONSTANT_MAP = {
  signup:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/signup_taskly",
  signup_with_verification:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/signup_with_verification",
  signin:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/signin_taskly",
  google_signin:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/google_signin",
  search: "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/search",
  create_task:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/create_task",
  fetch_task_time_windows:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/fetch_task_time_windows",
  // fetch_tasks: "https://api.doitly.co/api/tasks/fetch_tasks",
  fetch_tasks:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/fetch_tasks",

  create_task_offer:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/create_task_offer",
  fetch_avg_offer:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/fetch_avg_task_offer",
  create_task_question:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/create_task_question",
  fetch_task_questions:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/fetch_task_questions",
  post_task_question_reply:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/post_task_question_reply",
  update_task_offer:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/update_task_offer",
  fetch_user_tasks:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/fetch_user_tasks",
  update_task:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/update_task",
  fetch_task_by_id:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/fetch_task_by_id",
  get_posted_task_summary:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/get_posted_task_summary",
  cancel_task:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/cancel_task",
  get_cancelled_tasks:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/get_cancelled_tasks",
  undo_cancel_task:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/undo_cancel_task",
  get_offers_by_task:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/get_offers_by_task",
  get_account_info:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/get_account_info",
  update_account_details_v2:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/update_account_details_v2",
  fetch_task_offers:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/fetch_task_offers",
  update_task_offer_status:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/update_task_offer_status",
  fetch_posted_tasks:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/fetch_posted_tasks",
  fetch_user_offers:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/fetch_user_offers",
  get_presigned_upload_url:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/get_presigned_url",
  update_account_avatar:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/update_account_avatar",
  list_conversations:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/list_conversations",
  get_conversation_messages:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/get_conversation_messages",
  mark_conversation_read:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/mark_conversation_read",
  send_conversation_message:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/send_conversation_message",
  fetch_single_task:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/fetch_single_task",
  update_password:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/update_password",
  forgot_password:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/forgot_password_email",
  reset_password:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/doitly_reset_password",
  fetch_user_profile:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/fetch_user_profile",
  fetch_user_profile_tasks:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/fetch_user_profile_tasks",

  update_account_password:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/update_account_password",
  get_zipcode_listings:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/get_zipcode_listings",
  validate_zipcode:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/validate_zipcode",
  search_postgres:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/search_postgres",
  update_conversation_read:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/update_conversation_read",
  get_unread_count:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/get_doitly_unread_count",
  update_task_status:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/update_task_status",
  submit_task_question:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/submit_task_question",
  edit_task_question:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/edit_task_question",
  edit_task_question_reply:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/edit_task_question_reply",

  // New conflict-safe email verification endpoints
  signup_with_verification:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/signup_with_verification",
  verify_email:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/doitly_verify_email",

  // User search tracking endpoints
  store_user_search:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/store_user_search",
  get_user_search_history:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/get_user_search_history",

  // Categories endpoints
  fetch_categories:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/fetch_categories",

  // Notification preferences endpoints
  create_notification_preference:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/create_notification_preference",
  fetch_notification_preferences:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/fetch_notification_preferences",
  update_notification_preference:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/update_notification_preference",
  delete_notification_preference:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/delete_notification_preference",
  
  // Onboarding endpoints
  process_onboarding:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/process_onboarding",
    
  // Email tracking endpoints
  track_click:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/track_click",
    
  // Reporting endpoints
  submit_report:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/submit_report",

  // Account management
  delete_account:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/delete_account",

  // Reviews endpoints
  submit_review:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/submit_review",
  fetch_user_reviews:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/fetch_user_reviews",
  fetch_task_review:
    "https://k36dlnf1uf.execute-api.us-west-2.amazonaws.com/prod/fetch_task_review",
};
